module.exports = __webpack_public_path__ + "img/version-icon.6f572c93.svg";